import { render } from "./SuspenseExample.vue?vue&type=template&id=7231dddc"
import script from "./SuspenseExample.vue?vue&type=script&lang=js"
export * from "./SuspenseExample.vue?vue&type=script&lang=js"

import "./SuspenseExample.vue?vue&type=style&index=0&id=7231dddc&lang=css"
script.render = render

export default script